export default __webpack_public_path__ + "static/media/staff.6f947f80.png";